import React from 'react';
import { Routes, Route, Navigate  } from 'react-router-dom';
import EmployeeDashboard from '../pages/EmployeeDashboard';
import Profile from '../components/employee/Profile';
import AssignedCandidatesList from '../components/employee/AssignedCandidatesList';
import CandidateDetails from '../components/employee/CandidateDetails';

const EmployeeRoutes = () => {
  return (
    <Routes>
      <Route index element={<Navigate to="dashboard" />} />
      <Route path="dashboard" element={<EmployeeDashboard />} />
      <Route path="profile" element={<Profile />} />
      <Route path="assignedCandidates" element={<AssignedCandidatesList />} />
      <Route path="candidateDetails/:id" element={<CandidateDetails />} />
    </Routes>
  );
};

export default EmployeeRoutes;